import { RoleEnum } from '@anecdotes/auth-core';

export function getIconForRole(role: string): string {
  switch (role) {
    case RoleEnum.Admin:
      return 'user-types/admin';
    case RoleEnum.It:
      return 'user-types/it';
    case RoleEnum.Auditor:
      return 'user-types/auditor';
    case RoleEnum.Collaborator:
    case RoleEnum.Manager:
      return 'user-types/collaborator';
    case RoleEnum.TrustCenterAccessManager:
      return 'user-types/trust-center-access-manager';
    case 'stakeholder':
    case RoleEnum.Stakeholder:
      return 'user-types/stakeholder';
    case RoleEnum.Contributor:
      return 'user-types/contributor';
    case RoleEnum.Viewer:
      return 'user-types/viewer';
    case 'virtual':
      return 'eye-crossed';
    default:
      return 'user-types/custom';
  }
}
